import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ThrowError',
  props: {
    message: {}
  },
  setup(__props: any) {

const props = __props
throw new Error(props.message || 'Unexpected Error Ocurrred')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "Should never see this"))
}
}

})